import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { setSocialSelectModal } from "./formSlice";
import { setShowServerErrorMessage } from "./errorManagementSlice";
import errorStatusProvider from "../utils/errorStatusProvider";

const initialState = {
  page_content: null,
  loading: true,
  error: null,
};

const baseUrl = process.env.REACT_APP_API;

export const fetchSocialSelectModal = createAsyncThunk(
  "socialSelectModal/fetchSocialSelectModal",
  async (country) => {
    return fetch(
      `${baseUrl}/api/registration-form-page/5/${country.countryCode}/`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Accept-Language":
            country.language === "en" ? "en-UK" : country.language,
        },
      }
    ).then((res) => errorStatusProvider(res));
  }
);

export const getSocialSelectModal =
  (countryCode, language) => async (dispatch) => {
    const result = await dispatch(
      fetchSocialSelectModal({ countryCode, language })
    );
    const { data, responseStatus } = result.payload;
    dispatch(setShowServerErrorMessage(responseStatus));
    dispatch(setSocialSelectModal(data?.page_content));

    return data;
  };

export const socialSelectModalSlice = createSlice({
  name: "socialSelectModal",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialSelectModal.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSocialSelectModal.fulfilled, (state, action) => {
        state.loading = false;
        state.page_content = action.payload.data.page_content;
      })
      .addCase(fetchSocialSelectModal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error;
      });
  },
});

export default socialSelectModalSlice.reducer;
